import { useQuery } from '@tanstack/react-query';
import { fetchS3Json } from '../services/s3';

export function useS3Data<T>(key: string, enabled = true) {
  return useQuery<T>({
    queryKey: ['s3', key],
    queryFn: () => fetchS3Json<T>(key),
    enabled: enabled && !!key,
    refetchOnWindowFocus: false,
  });
}
